(() => {
  const initNavigation = (root) => {
    if (!root || root.dataset.coreNavigationReady === 'true') return;
    root.dataset.coreNavigationReady = 'true';

    const desktop = window.matchMedia('(min-width: 1121px)');
    const items = [...root.querySelectorAll('.pw-nav__desktop [data-core-nav-item]')];
    let openTimer = 0;
    let closeTimer = 0;

    const clearTimers = () => {
      window.clearTimeout(openTimer);
      window.clearTimeout(closeTimer);
    };

    const closeAll = (except = null) => {
      items.forEach((item) => {
        if (item !== except) item.open = false;
      });
    };

    const openItem = (item, immediate = false) => {
      if (!desktop.matches) return;
      clearTimers();
      const apply = () => {
        closeAll(item);
        item.open = true;
      };
      if (immediate) apply();
      else openTimer = window.setTimeout(apply, 90);
    };

    const closeItem = (item) => {
      if (!desktop.matches) return;
      clearTimers();
      closeTimer = window.setTimeout(() => {
        if (!item.matches(':hover') && !item.contains(document.activeElement)) item.open = false;
      }, 180);
    };

    const activatePanel = (item, panelId, focusTab = false) => {
      const tabs = [...item.querySelectorAll('[data-core-nav-tab]')];
      const panels = [...item.querySelectorAll('[data-core-nav-panel]')];
      tabs.forEach((tab) => {
        const active = tab.dataset.coreNavTab === panelId;
        tab.classList.toggle('is-active', active);
        tab.setAttribute('aria-selected', active ? 'true' : 'false');
        tab.tabIndex = active ? 0 : -1;
        if (active && focusTab) tab.focus();
      });
      panels.forEach((panel) => {
        const active = panel.dataset.coreNavPanel === panelId;
        panel.classList.toggle('is-active', active);
        panel.hidden = !active;
      });
    };

    items.forEach((item) => {
      const summary = item.querySelector(':scope > summary');
      const tabs = [...item.querySelectorAll('[data-core-nav-tab]')];

      item.addEventListener('toggle', () => {
        if (item.open) closeAll(item);
      });
      item.addEventListener('pointerenter', () => openItem(item));
      item.addEventListener('pointerleave', () => closeItem(item));
      item.addEventListener('focusin', (event) => {
        if (event.target === summary) return;
        openItem(item, true);
      });
      item.addEventListener('focusout', () => closeItem(item));

      summary?.addEventListener('click', (event) => {
        if (!desktop.matches) return;
        event.preventDefault();
        if (item.open) item.open = false;
        else openItem(item, true);
      });

      tabs.forEach((tab, index) => {
        const select = () => activatePanel(item, tab.dataset.coreNavTab);
        tab.addEventListener('pointerenter', select);
        tab.addEventListener('focus', select);
        tab.addEventListener('click', select);
        tab.addEventListener('keydown', (event) => {
          let next = null;
          if (event.key === 'ArrowDown') next = (index + 1) % tabs.length;
          if (event.key === 'ArrowUp') next = (index - 1 + tabs.length) % tabs.length;
          if (event.key === 'Home') next = 0;
          if (event.key === 'End') next = tabs.length - 1;
          if (next === null) return;
          event.preventDefault();
          activatePanel(item, tabs[next].dataset.coreNavTab, true);
        });
      });
    });

    root.addEventListener('click', (event) => {
      if (desktop.matches && event.target.closest('a')) closeAll();
    });
    document.addEventListener('click', (event) => {
      if (!root.contains(event.target)) closeAll();
    });
    document.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape') return;
      const active = items.find((item) => item.open);
      closeAll();
      active?.querySelector(':scope > summary')?.focus({ preventScroll: true });
    });
    desktop.addEventListener?.('change', () => {
      clearTimers();
      closeAll();
      root.querySelectorAll('.pw-nav__mobile-label, .pw-nav__list--mobile details').forEach((details) => { details.open = false; });
    });
  };

  const initAll = () => document.querySelectorAll('[data-core-navigation]').forEach(initNavigation);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll, { once: true });
  else initAll();
  document.addEventListener('shopify:section:load', initAll);
})();
